import { render, staticRenderFns } from "./BarEchartTicket.vue?vue&type=template&id=279dae60&"
import script from "./BarEchartTicket.vue?vue&type=script&lang=js&"
export * from "./BarEchartTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports